import { useEffect, useState } from 'react';
import { api, errorMessage } from '../../shared/api/client';
import { Alert, Button } from '../../shared/ui/components';

const REFRESH_MS = 2000;

/**
 * Vista temporal de una cámara. Primero se pide un permiso (dura 10 minutos) y luego cada imagen
 * pasa por KEORA con la sesión. Al vencer, se deja de mostrar.
 */
export function CameraViewer({ churchId, cameraId, name }: { churchId: string; cameraId: string; name: string }) {
  const [grant, setGrant] = useState<{ grantId: string; expiresAt: string } | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [tick, setTick] = useState(0);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!grant) return;
    const id = window.setInterval(() => {
      setNow(Date.now());
      setTick((t) => t + 1);
    }, REFRESH_MS);
    return () => window.clearInterval(id);
  }, [grant]);

  const left = grant ? Math.max(0, new Date(grant.expiresAt).getTime() - now) : 0;
  useEffect(() => {
    if (grant && left === 0) setGrant(null);
  }, [grant, left]);

  async function open() {
    setBusy(true);
    setError(null);
    try {
      setGrant(await api.post<{ grantId: string; expiresAt: string }>(`/nursery/churches/${churchId}/cameras/${cameraId}/access`));
      setNow(Date.now());
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setBusy(false);
    }
  }

  if (!grant) {
    return (
      <div className="camera">
        {error ? <Alert>{error}</Alert> : null}
        <Button type="button" variant="secondary" busy={busy} onClick={open}>
          Ver cámara: {name}
        </Button>
      </div>
    );
  }
  const mins = Math.floor(left / 60_000);
  const secs = Math.floor((left % 60_000) / 1000);
  return (
    <div className="camera">
      <img
        className="camera__frame"
        src={`/api/nursery/churches/${churchId}/camera-grants/${grant.grantId}/frame?t=${tick}`}
        alt={`Cámara ${name}`}
        onError={() => {
          setGrant(null);
          setError('La cámara dejó de estar disponible para ti.');
        }}
      />
      <div className="camera__bar">
        <span className="small muted">
          Acceso temporal · {mins}:{String(secs).padStart(2, '0')}
        </span>
        <Button type="button" variant="ghost" onClick={() => setGrant(null)}>
          Cerrar
        </Button>
      </div>
    </div>
  );
}
